module.exports = __webpack_public_path__ + "static/media/logo-crypto-shield.ec20e7ab.svg";